var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-btn",class:{'grey': !_vm.canUse, 'blue': _vm.blue},style:(_vm.style),on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }